/**
 * Calcule la couleur de texte optimale (noir ou blanc) pour un fond donné.
 * Utilise la formule YIQ (luminance perçue) pour garantir le contraste.
 * @param {string} hexcolor - Couleur hex (ex: "#3B82F6")
 * @returns {string} "#1F2937" (noir foncé) ou "#FFFFFF" (blanc)
 */
export function getContrastYIQ(hexcolor) {
  if (!hexcolor) return '#FFFFFF';
  const hex = hexcolor.replace('#', '');
  if (hex.length < 6) return '#FFFFFF';
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? '#1F2937' : '#FFFFFF';
}

/**
 * Retourne une version lisible de la couleur sur fond blanc.
 * Si la couleur est trop claire (YIQ >= 160), elle est assombrie de 50%
 * pour rester dans la même teinte mais être lisible sur blanc.
 * @param {string} hexcolor - Couleur hex
 * @returns {string} Couleur hex assombrie si nécessaire
 */
export function getReadableColorOnWhite(hexcolor) {
  if (!hexcolor) return '#3B82F6';
  const hex = hexcolor.replace('#', '');
  if (hex.length < 6) return hexcolor;
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  if (yiq < 160) return hexcolor; // Déjà assez sombre, OK sur blanc
  // Assombrir de 50% pour rester dans la teinte mais être lisible
  r = Math.round(r * 0.50);
  g = Math.round(g * 0.50);
  b = Math.round(b * 0.50);
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}
